import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  baseUrl = environment.apiUrl + 'Downloads';

  constructor(private http: HttpClient, private router: Router, private _location: Location) {}

  getAllDownloads(page, filters): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(this.baseUrl + `?pg=${page}`, { observe: 'response', params: filters });
  }

  deleteDownload(id): Observable<HttpResponse<any[]>> {
    return this.http.delete<any[]>(this.baseUrl + `?id=${id}`, { observe: 'response' });
  }

  downloadReport(id): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + `/download/${id}`, { observe: 'response', responseType: 'blob' });
  }
} 
